import { Component, OnInit, computed, effect, inject, input, output } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ReferenceMeasurementItemLengthComponent } from "@components/reference-measurement-item-length/reference-measurement-item-length.component";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { Wire } from "@domain/project/floorplan/wiring/wire";
import { DisabledController } from "@odx/angular";
import { FormDirective, FormFieldComponent, FormFieldControlDirective } from "@odx/angular/components/form-field";
import { TooltipDirective } from "@odx/angular/components/tooltip";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";

@Component({
  selector: "app-wire-notes",
  imports: [
    FloorplanItemDetailsComponent,
    FormDirective,
    FormFieldComponent,
    FormFieldControlDirective,
    FormsModule,
    ReactiveFormsModule,
    DisabledController,
    ReferenceMeasurementItemLengthComponent,
    TooltipDirective,
  ],
  templateUrl: "./wire-notes.component.html",
  styleUrl: "./wire-notes.component.scss",
  standalone: true,
})
export class WireNotesComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);

  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly floorplanItem = input.required<FloorplanItem>();
  readonly toggleExtendedButtonClicked = output<void>();

  protected readonly wire = computed(() => this.floorplanItem() as Wire);

  protected wireForm?: FormGroup;
  protected readonly tooltipTextDeprecatedLength: string = $localize`:@@floorplan.length.deprecated:Dieses Feld ist veraltet und wird zeitnah entfernt`;

  constructor() {
    effect(() => {
      const wire = this.wire();
      this.wireForm?.reset(
        {
          name: wire.name,
          type: wire.type,
          scalingLength: wire.scalingLength,
        },
        { emitEvent: false },
      );
    });
  }

  ngOnInit() {
    this.initForm();
  }

  private update(): void {
    this.wire().updateMetadata(this.wireForm!.value.type, this.wireForm!.value.scalingLength, this.wireForm!.value.name);
    this.wire().name = this.wireForm!.value.name;
  }

  private initForm() {
    this.wireForm = this.formBuilder.group({
      name: [this.wire().name],
      type: [this.wire().type],
      scalingLength: [this.wire().scalingLength],
    });

    this.wireForm.valueChanges.subscribe(() => {
      if (!this.wireForm!.valid || this.wireForm!.pristine) return;
      this.update();
    });
  }
}
